// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7134":"434e98dd","9562":"8f865c0d"}[chunkId] + ".chunk.css";
};